import script from "./AppNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNotification.vue?vue&type=script&setup=true&lang=js"

import "./AppNotification.vue?vue&type=style&index=0&id=c6f54f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6f54f28"]])

export default __exports__